import { parseISO } from 'date-fns';

interface FormatDateOptions {
  format?: 'user' | 'system' | 'system-time';
  defaultValue?: string;
}

const userFormatOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

const systemFormatOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

const systemTimeFormatOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
};

export function formatDate(
  date?: Date | string | null,
  { format = 'system', defaultValue }: FormatDateOptions = {},
): string {
  if (!date) return defaultValue ?? '';

  const dateObj = typeof date === 'string' ? parseISO(date) : date;

  if (isNaN(dateObj.getTime())) {
    return defaultValue ?? '';
  }

  if (format === 'system-time') {
    return dateObj.toLocaleTimeString('en-US', systemTimeFormatOptions).toLowerCase();
  }

  return dateObj.toLocaleDateString(
    'en-US',
    format === 'user' ? userFormatOptions : systemFormatOptions,
  );
}

export function convertMetersToMiles(distance: number) {
  return (distance / 1609.34).toFixed(2);
}

export function formatPrice(price: number) {
  return `$${price.toFixed(2)}`;
}
